<template>
  <div class="home-page">
    <site-header />
    <div class="home">
      <!-- Banner -->
      <section class="banner-new">
        <swiper :options="swiperOptions" class="my-swiper">
          <!-- 第一张：企业用工风险解决专家 -->
          <!-- <swiper-slide v-if="false">
            <div class="contant-swiper2 flex-center">
              <div class="left2">
                <p class="swiper-title1">企业用工风险解决专家</p>
                <p class="swiper-title2">行业领先 | 精准赋能 | 持续陪伴式服务</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <div class="right-box">
                <div class="right">
                  <div class="swiper-card-item dw1">
                    <p>工商注册信息核查</p>
                    <span>核验企业/个体工商户注册信息及经营状态</span>
                  </div>
                  <div class="swiper-card-item dw2">
                    <p>运营商信息</p>
                    <span>核查手机号状态、入网时长、通话及活跃情况</span>
                  </div>
                  <div class="swiper-card-item dw3">
                    <p>身份信息核实</p>
                    <span>核验姓名、身份证号等身份信息真实性</span>
                  </div>
                  <div class="swiper-card-item dw4">
                    <p>金融信贷风险核查</p>
                    <span>评估信贷逾期记录、负债及还款风险</span>
                  </div>
                  <div class="swiper-card-item dw5">
                    <p>黑名单(非银行机构)</p>
                    <span>核查是否存在于非银行机构黑名单中</span>
                  </div>
                  <div class="swiper-card-item dw6">
                    <p>高风险核查</p>
                    <span>核查执行公告、曝光台、失信、判决文书、开庭公告、法院公告等风险信息</span>
                  </div>
                  <img src="@/assets/images/img1.png" alt="" class="image" />
                </div>
              </div>
            </div>
          </swiper-slide> -->

          <swiper-slide>
            <div class="banner-bg">
              <div class="left banner-left">
                <p class="swiper-title1">企业用工风险解决专家</p>
                <p class="swiper-title2">行业领先 | 精准赋能 | 持续陪伴式服务</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <img src="@/assets/images/b1.png">
            </div>
          </swiper-slide>

          <!-- 第二张：稳定且强大的服务系统 不用-->
          <!-- <swiper-slide>
            <div class="banner-bg">
              <div class="left banner-left">
                <p class="swiper-title1">稳定且强大的服务系统</p>
                <p class="swiper-title2">自有技术团队，系统稳定，可随时优化调整</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <img src="@/assets/images/b2.png">
            </div>
          </swiper-slide> -->

          <!-- 第三张：稳定且强大的服务系统 不用-->
          <!-- <swiper-slide>
            <div class="banner-bg">
              <div class="left banner-left">
                <p class="swiper-title1">稳定且强大的服务系统</p>
                <p class="swiper-title2">自有技术团队，系统稳定，可随时优化调整</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <img src="@/assets/images/banner2_new2.png">
            </div>
          </swiper-slide> -->

          <swiper-slide>
            <div class="banner-bg">
              <div class="left banner-left">
                <p class="swiper-title1">稳定且强大的服务系统</p>
                <p class="swiper-title2">自有技术团队，系统稳定，可随时优化调整</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <img src="@/assets/images/b3.png">
            </div>
          </swiper-slide>

          <swiper-slide>
            <div class="banner-bg">
              <div class="left banner-left">
                <p class="swiper-title1">智能化员工背景调查服务提供商</p>
                <p class="swiper-title2">快速有效防范招聘风险，让职业信用环境更美好</p>
                <button type="button" class="btn-zxzx" @click="handleConsult">咨询了解</button>
              </div>
              <img src="@/assets/images/b4.png">
            </div>
          </swiper-slide>
        </swiper>
      </section>

      <!-- 构建人力资源安全体系 -->
      <section class="back-tone mod t-l">
        <div class="mod-title">
          <div class="title">构建人力资源安全体系</div>
          <div class="sed-title">武汉云查信息技术有限公司专注产品体系研究，覆盖全场景的雇佣安全管理</div>
        </div>
        <div class="content container">
          <div class="cards-row">
            <div v-for="(product, index) in products" :key="product.name" class="card-col">
              <div class="card-title pointer" :class="{ active: activeProduct === index }"
                @click="activeProduct = index">
                {{ product.name }}
              </div>
              <div class="card">
                <div class="up">
                  <div class="title">{{ product.version }}</div>
                  <div class="sub-title">{{ product.position }}</div>
                </div>
                <div class="down">
                  <ul class="clear">
                    <li v-for="item in product.items" :key="item">{{ item }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 全流程在线化操作 -->
      <section class="plant-wide mod t-c">
        <div class="mod-title">
          <div class="title">全流程在线化操作</div>
          <div class="sed-title">安全合规的流程，快速交付每一份严谨客观的背调报告</div>
        </div>
        <div class="step-box">
          <img src="@/assets/images/step_new_2.png" alt="" class="step-image" />
        </div>
      </section>

      <!-- 我们的背调优势 -->
      <section class="back-advantage mod t-c">
        <div class="mod-title">
          <div class="title">我们的背调优势</div>
          <div class="sed-title">致力于成为中国领先的智能化背景调查提供商</div>
        </div>
        <div class="content container flex-center advantages-box">
          <div v-for="item in advantages" :key="item.title" class="item">
            <div class="icon">
              <img :src="item.icon" alt="" />
            </div>
            <div class="title">{{ item.title }}</div>
            <div class="detail">{{ item.detail }}</div>
          </div>
        </div>
      </section>

      <section class="cooperate-partenrs mod t-c">
        <div class="mod-title">
          <div class="title">合作客户与案例</div>
          <div class="sed-title">丰富的各行业客服对接和服务经验</div>
        </div>
        <div class="content container flex-center partners-box">
          <div v-for="item in partners" :key="item.dictCode" class="item">
            <div class="icon">
              <img :src="item.dictValue" alt="" />
            </div>
            <div class="company-name">{{ item.dictLabel }}</div>
          </div>
        </div>
      </section>
    </div>
    <site-footer />
    <site-aside ref="asideRef" />
  </div>
</template>

<script>
import SiteHeader from '@/components/layout/SiteHeader.vue'
import SiteFooter from '@/components/layout/SiteFooter.vue'
import SiteAside from '@/components/layout/SiteAside.vue'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
  name: 'HomeView',
  components: {
    SiteHeader,
    SiteFooter,
    SiteAside,
    Swiper,
    SwiperSlide
  },
  computed: {
    partners() {
      return this.$store.getters.sysDictDataList || []
    }
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        }
      },
      typedText: '',
      typedWords: ['背调', '背景调查', '雇佣安全', '人才审计'],
      wordIndex: 0,
      charIndex: 0,
      isDeleting: false,
      typingTimer: null,
      activeProduct: 0,
      activeStep: 0,
      activeTab: 0,
      bannerBank: require('@/assets/images/banner-bank.png'),
      bannerPic: require('@/assets/images/banner-pic.png'),
      backToneCard: require('@/assets/images/back-tone-card.png'),
      backWideBg: require('@/assets/images/back-wide-bg.png'),
      certImages: [
        require('@/assets/images/02.png'),
        require('@/assets/images/03.png'),
        require('@/assets/images/04.png'),
        require('@/assets/images/05.png')
      ],
      products: [
        {
          name: '面试预检',
          version: '迅捷版',
          deliveryTime: '10秒',
          position: '适用岗位：基层 / 蓝领',
          items: ['身份验证', '运营商信息', '个人工商信息', '国内学历核验', '个人收入等级', '金融信贷风险核查', '黑名单(非银行机构)',
            '诉讼记录核查']
        },
        {
          name: '入职前背调',
          version: '标准版',
          deliveryTime: '2个工作日',
          position: '适用岗位：普通白领',
          items: ['身份验证', '运营商信息', '个人工商信息', '国内学历核验', '职业经济能力评估', '综合型收入预测指数', '金融信贷风险核查', '黑名单(非银行机构)',
            '诉讼记录核查']
        }
      ],
      processSteps: [
        {
          icon: require('@/assets/images/plant-wide01.png'),
          title: '企业发起背调',
          detail: '可通过武汉云查信息技术有限公司平台或<br>第三方招聘系统发起'
        },
        {
          icon: require('@/assets/images/plant-wide02.png'),
          title: '候选人在线授权',
          detail: '武汉云查信息技术有限公司自动发送短信<br>候选人电子签授权'
        },
        {
          icon: require('@/assets/images/plant-wide03.png'),
          title: '基础客观项验证',
          detail: '对接全数据源<br>秒级查询'
        },
        {
          icon: require('@/assets/images/plant-wide04.png'),
          title: '工作履历调查',
          detail: '优先自主寻访HR<br>对证明人进行验证'
        },
        {
          icon: require('@/assets/images/plant-wide05.png'),
          title: '背调报告质检',
          detail: '对背调过程与报告质量<br>进行质检'
        },
        {
          icon: require('@/assets/images/plant-wide05.png'),
          title: '交付背调报告',
          detail: '企业收到查验PDF报告<br>顾问对报告解读'
        }
      ],
      advantages: [
        {
          icon: require('@/assets/images/ys1.png'),
          title: '高效交付深度的履历调查',
          detail: '依托庞大的自有HR证明人资源以及证明人验证系统，针对履历的调查我们优先自主寻访HR，大幅提升履历真实度还原。'
        },
        {
          icon: require('@/assets/images/ys2.png'),
          title: '优质合规的数据资源',
          detail: '获得众多合规数据源授权查询，包括司法体系、征信持证机构、教育系统等。通过API对接实时查询，进一步保障数据精准度。'
        },
        {
          icon: require('@/assets/images/ys3.png'),
          title: '丰富的平台对接经验',
          detail: '依据合作平台特点，背调服务可在平台的集成场景，与合作平台一起为客户建立更全面的人力资源服务。'
        },
        {
          icon: require('@/assets/images/ys4.png'),
          title: '专业的背调顾问团队',
          detail: '武汉云查信息技术有限公司拥有专业的背调顾问团队，具备丰富的行业经验和专业知识，为客户提供个性化的咨询和解决方案。'
        },
        {
          icon: require('@/assets/images/ys5.png'),
          title: '严格的隐私保护措施',
          detail: '武汉云查信息技术有限公司严格遵守相关法律法规，采取多种技术手段和管理措施，确保客户数据的安全和隐私。'
        },
        {
          icon: require('@/assets/images/ys6.png'),
          title: '持续的技术创新',
          detail: '武汉云查信息技术有限公司不断进行技术创新，优化背调流程和工具，提高效率和准确性，为客户提供更优质的服务。'
        }
      ],
      // partners: [
      //   {
      //     logo: require('@/assets/images/partners/1.jpg'),
      //     name: '盛智塑料包装',
      //   },
      //   {
      //     logo: require('@/assets/images/partners/2.png'),
      //     name: '盛鑫包装',
      //   },
      //   {
      //     logo: require('@/assets/images/partners/3.jpg'),
      //     name: '悦鑫伟业纸塑包装',
      //   },
      //   {
      //     logo: require('@/assets/images/partners/13.png'),
      //     name: '小豹信息技术',
      //   },
      //   {
      //     logo: require('@/assets/images/partners/5.png'),
      //     name: '宏安法律咨询',
      //   },
      //   {
      //     logo: require('@/assets/images/partners/6.png'),
      //     name: '豹付科技'
      //   },
      //   {
      //     logo: require('@/assets/images/partners/7.png'),
      //     name: '拾贰映画'
      //   },
      //   {
      //     logo: require('@/assets/images/partners/8.png'),
      //     name: '百融智能'
      //   },
      //   {
      //     logo: require('@/assets/images/partners/9.png'),
      //     name: '东盈金数'
      //   },
      //   {
      //     logo: require('@/assets/images/partners/10.png'),
      //     name: '诺尔智汇'
      //   },
      //   {
      //     logo: require('@/assets/images/partners/11.png'),
      //     name: '汉嘉煜网络'
      //   },
      //   {
      //     logo: require('@/assets/images/partners/4.png'),
      //     name: '海屯科技'
      //   },
      //   {
      //     logo: require('@/assets/images/partners/12.png'),
      //     name: '善缘文化'
      //   }
      // ]
    }
  },
  mounted() {
    this.startTyping()
  },
  beforeDestroy() {
    clearTimeout(this.typingTimer)
  },
  methods: {
    handleConsult() {
      const phone = '400-8600-575'
      // 判断移动端
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      // console.log("isMobile",isMobile);
      if (isMobile) {
        window.location.href = `tel:${phone}`
      } else {
        setTimeout(() => {
          this.$refs.asideRef.openPopover()
        }, 80)
      }
    },
    startTyping() {
      const tick = () => {
        const currentWord = this.typedWords[this.wordIndex]
        if (!this.isDeleting) {
          this.typedText = currentWord.substring(0, this.charIndex + 1)
          this.charIndex++
          if (this.charIndex === currentWord.length) {
            this.isDeleting = true
            this.typingTimer = setTimeout(tick, 2000)
            return
          }
        } else {
          this.typedText = currentWord.substring(0, this.charIndex - 1)
          this.charIndex--
          if (this.charIndex === 0) {
            this.isDeleting = false
            this.wordIndex = (this.wordIndex + 1) % this.typedWords.length
          }
        }
        this.typingTimer = setTimeout(tick, this.isDeleting ? 80 : 150)
      }
      tick()
    }
  }
}
</script>

<style lang="scss" scoped>
// ===== 全局重置 =====
* {
  box-sizing: border-box;
}

.home-page {
  min-height: 100vh;
  overflow-x: hidden;
}

.home {
  padding-top: 72px;
  overflow-x: hidden;
}

.container {
  width: 100%;
  margin: 0 auto;
  padding: 50px 200px;
}

// ===== 工具类 =====
.flex-center {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.bold {
  font-weight: 600;
}

.pointer {
  cursor: pointer;
}

.clear::after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

// ===== Swiper =====
.my-swiper {
  width: 100%;
  height: 598px;
  overflow: visible !important;
}

.swiper-slide {
  display: flex;
  align-items: center;
  justify-content: center;
}

// ===== Banner 通用样式 =====
.banner-new {
  height: 598px;

  // 通用标题样式
  .swiper-title1 {
    font-size: 50px;
    font-weight: 800;
    color: #fff;
    line-height: 1.2;
    text-align: left;
  }

  .swiper-title2 {
    font-size: 22px;
    color: #fff;
    line-height: 1.4;
    text-align: left;
  }

  .btn-zxzx {
    display: block;
    width: 180px;
    height: 58px;
    font-size: 19px;
    font-weight: 800;
    line-height: 58px;
    margin-top: 60px;
    cursor: pointer;
    transition: opacity 0.3s;
    color: white;
    border: 1px solid #fff !important;
    background: transparent !important;

    &:hover {
      opacity: 0.9;
      background: rgba(255, 255, 255, 0.1) !important;
    }
  }

  // ===== 第一张 Banner: 企业用工风险解决专家 =====
  .contant-swiper2 {
    width: 100%;
    height: 598px;
    background: linear-gradient(180deg, #0A5FE8, #3794E0);
    position: relative;
    overflow: hidden;

    .left2 {
      padding-top: 72px;
      padding-bottom: 72px;
      position: absolute;
      top: 1%;
      left: 10%;
      z-index: 2;
    }

    .right-box {
      width: 650px;
      height: 598px;
      padding-right: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 3%;
      right: 15%;
      z-index: 1;
    }

    .right {
      height: 598px;
      margin-left: 30px;
      padding-right: 40px;
      width: 1000px;
      flex-shrink: 0;
      position: relative;

      .swiper-card-item {
        width: 150px;
        min-height: 80px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        background: rgba(36, 96, 202, 0.85);
        border-radius: 8px;
        padding: 10px;
        position: absolute;
        backdrop-filter: blur(4px);
        transition: transform 0.3s;

        p {
          font-size: 14px;
          font-weight: 600;
          color: #fff;
          margin: 0 0 4px;
        }

        span {
          font-size: 12px;
          color: rgba(255, 255, 255, 0.9);
          text-align: left;
        }

        &:hover {
          transform: scale(1.05);
        }
      }

      .dw1 {
        position: absolute;
        bottom: 180px;
        left: 130px;
      }

      .dw2 {
        position: absolute;
        bottom: 350px;
        left: 200px;
      }

      .dw3 {
        position: absolute;
        top: 50px;
        left: 380px;
      }

      .dw4 {
        position: absolute;
        top: 80px;
        right: 250px;
      }

      .dw5 {
        position: absolute;
        top: 200px;
        right: 200px;
      }

      .dw6 {
        position: absolute;
        bottom: 160px;
        right: 110px;
        width: 180px;
      }

      .image {
        width: 350px;
        max-width: 100%;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  // ===== 第二张 Banner: 稳定且强大的服务系统 =====
  .banner-bg {
    position: relative;
    width: 100%;
    height: 598px;
    display: flex;
    align-items: center;

    img {
      width: 100%;
      height: 598px;
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
    }

    .banner-left {
      position: absolute;
      z-index: 1;
      padding-top: 72px;
      padding-bottom: 72px;
      padding-left: 0;
      left: 10%;

      .swiper-title1,
      .swiper-title2 {
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
      }
    }
  }
}

// ===== 模块标题 =====
.mod-title {
  text-align: center;
  padding: 60px 0 40px;

  .title {
    font-size: 32px;
    font-weight: 600;
    color: #111;
    line-height: 1.4;
    letter-spacing: 1px;
  }

  .sed-title {
    font-size: 16px;
    color: #29375b;
    line-height: 1.4;
    padding-top: 14px;
  }
}

// ===== 产品卡片 =====
.back-tone {
  background: #fff;

  .mod-title {
    margin-bottom: 32px;
  }

  .cards-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin: 0 auto;
  }

  .card-col {
    flex: 1;
    min-width: 0;
  }

  .card-title {
    font-size: 18px;
    font-weight: 800;
    color: #29375b;
    line-height: 25px;
    border-top: 1px solid #eff2f6;
    padding: 27px 0;
    text-align: center;
    transition: border-color 0.3s;

    &.active {
      border-top: 2px solid #104aba;
    }
  }

  .card {
    width: 100%;
    min-height: 340px;
    background: #fff;
    box-shadow: 0 8px 28px 0 rgba(9, 37, 64, 0.06);
    border-radius: 8px;
    border: 1px solid #dbdfe7;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    transition: all 0.3s;

    &:hover {
      box-shadow: 0 20px 30px 0 rgba(53, 59, 69, 0.2);
      border-radius: 10px;
    }

    .up {
      padding: 10px 16px;
      border-bottom: 1px dashed #e8e8e8;

      .title {
        margin-bottom: 8px;
        font-size: 24px;
        font-weight: 700;
        color: #111;
        line-height: 32px;
      }

      .sub-title {
        color: #111;
        font-size: 14px;
      }
    }

    .down {
      padding: 16px 20px;

      ul {
        margin: 0;
        padding: 0;
        list-style: none;

        li {
          float: left;
          margin-bottom: 22px;
          width: calc(50% - 12px);
          font-size: 16px;

          &:nth-child(odd) {
            margin-right: 24px;
          }

          &::before {
            content: '';
            background: #d3d9e4;
            margin-right: 4px;
            display: inline-block;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            vertical-align: middle;
            flex-shrink: 0;
          }
        }
      }
    }

    &.custom {
      padding: 123px 0 0;
      background: linear-gradient(180deg, #104aba, #1d5edc);
      color: #fff;
      text-align: left;
      position: relative;
      border: none;
      height: 300px;

      .title {
        margin: 0 24px 5px;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        color: #fff;
      }

      .detail {
        margin: 0 24px 18px;
        font-size: 16px;
        color: #fff;
        line-height: 22px;
      }

      img {
        width: 158px;
        bottom: -10%;
        right: 5%;
        position: absolute;
      }

      .btn {
        border: none;
        border-radius: 24px;
        height: 44px;
        width: 144px;
        font-size: 16px;
        font-weight: 600;
        color: #0053fa;
        line-height: 44px;
        background: #fff;
        margin: 0 24px 18px;
        cursor: pointer;

        &:hover {
          color: #3883fd;
        }
      }
    }
  }
}

// ===== 流程步骤 =====
.plant-wide {
  display: flex;
  flex-direction: column;
  align-items: center;

  .step-box {
    width: 100%;
    padding: 50px 200px 50px 200px;

    .step-image {
      width: 70%;
      height: auto;
    }
  }
}

// ===== 背调优势 =====
.back-advantage {
  margin-bottom: 40px;
  overflow: visible !important;

  .advantages-box {
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    padding: 0 200px;
    gap: 24px;
    overflow: visible !important;
    width: 100%;
  }

  .item {
    flex: 0 0 calc((100% - 48px) / 3);
    max-width: calc((100% - 48px) / 3);
    min-height: 321px;
    height: auto;
    border-radius: 8px;
    border: 1px solid #d3d9e4;
    padding: 25px;
    box-shadow: 0 8px 28px 0 rgba(9, 37, 64, 0.06);
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    overflow: visible !important;
    box-sizing: border-box;

    &:hover {
      box-shadow: 0 20px 30px 0 rgba(53, 59, 69, 0.2);
      border-radius: 10px;
    }

    .icon {
      width: 96px;
      height: 96px;
      margin: 0 auto 16px;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .title {
      font-size: 20px;
      font-weight: 800;
      color: #29375b;
      line-height: 1.4;
      margin-bottom: 14px;
      word-break: break-word;
      width: 100%;
    }

    .detail {
      font-size: 16px;
      color: #29375b;
      line-height: 1.8;
      text-align: left;
      flex: 1;
      word-break: break-word;
      overflow-wrap: break-word;
      max-width: 100%;
      width: 100%;
    }
  }
}

//合作伙伴
// .cooperate-partenrs {
//   margin-bottom: 40px;
//   overflow: visible !important;

//   .partners-box {
//     margin: 0 auto;
//     display: flex;
//     flex-wrap: wrap;
//     padding: 0 200px;
//     gap: 12px;
//     overflow: visible !important;
//     width: 100%;
//   }

//   .item {
//     flex: 0 0 calc((100% - 100px) / 6);
//     max-width: calc((100% - 100px) / 6);
//     min-height: 150px;
//     height: auto;
//     border-radius: 8px;
//     border: 1px solid #d3d9e4;
//     padding: 10px;
//     box-shadow: 0 8px 28px 0 rgba(9, 37, 64, 0.06);
//     transition: all 0.3s;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     text-align: center;
//     overflow: visible !important;
//     box-sizing: border-box;

//     &:hover {
//       box-shadow: 0 20px 30px 0 rgba(53, 59, 69, 0.2);
//       border-radius: 10px;
//     }

//     .icon {
//       width: 96px;
//       height: 96px;
//       margin: 0 auto;
//       flex-shrink: 0;

//       img {
//         width: 100%;
//         height: 100%;
//         object-fit: contain;
//       }
//     }

//     .company-name{
//       font-size: 14px;
//       font-weight: 600;
//       color: #29375b;
//     }

//     .title {
//       font-size: 20px;
//       font-weight: 800;
//       color: #29375b;
//       line-height: 1.4;
//       margin-bottom: 14px;
//       word-break: break-word;
//       width: 100%;
//     }

//     .detail {
//       font-size: 16px;
//       color: #29375b;
//       line-height: 1.8;
//       text-align: left;
//       flex: 1;
//       word-break: break-word;
//       overflow-wrap: break-word;
//       max-width: 100%;
//       width: 100%;
//     }
//   }
// }

// ===== 合作伙伴模块（完整优化版） =====
.cooperate-partenrs {
  margin-bottom: 80px;
  overflow: hidden; // 防止溢出

  .partners-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: center; // 居中对齐，更美观
    gap: 20px; // 统一间距
    padding: 0 200px;
    // max-width: 1400px;
    margin: 0 auto;
  }

  .item {
    flex: 0 0 calc((100% - 100px) / 6); // 默认一行6个
    max-width: calc((100% - 100px) / 6);
    min-height: 160px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #e8ecf1;
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    box-sizing: border-box;

    &:hover {
      // box-shadow: 0 12px 24px rgba(0, 0, 0, 0.10);
      // transform: translateY(-4px);
      // border-color: #104aba;
    }

    .icon {
      width: 80px;
      height: 80px;
      margin: 0 auto 12px;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        border-radius: 4px;
      }
    }

    .company-name {
      height: 35px;
      font-size: 14px;
      font-weight: 600;
      color: #29375b;
      // line-height: 1.4;
      word-break: break-word;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }

  // ----- 响应式断点 -----

  // 超大桌面 (≥1400px) - 维持6列
  // @media (min-width: 1400px) {
  //   .item {
  //     flex: 0 0 calc((100% - 100px) / 6);
  //     max-width: calc((100% - 100px) / 6);
  //   }
  // }

  // // 桌面 (1200px - 1399px) - 6列，缩小间距
  // @media (max-width: 1399px) and (min-width: 1200px) {
  //   .partners-box {
  //     gap: 16px;
  //     padding: 0 16px;
  //   }

  //   .item {
  //     flex: 0 0 calc((100% - 80px) / 6);
  //     max-width: calc((100% - 80px) / 6);
  //     min-height: 140px;
  //     padding: 16px 10px;

  //     .icon {
  //       width: 64px;
  //       height: 64px;
  //     }
  //   }
  // }

  // // 笔记本/小桌面 (992px - 1199px) - 改为4列
  // @media (max-width: 1199px) and (min-width: 992px) {
  //   .partners-box {
  //     gap: 16px;
  //     padding: 0 20px;
  //   }

  //   .item {
  //     flex: 0 0 calc((100% - 48px) / 4);
  //     max-width: calc((100% - 48px) / 4);
  //     min-height: 140px;

  //     .icon {
  //       width: 64px;
  //       height: 64px;
  //     }
  //   }
  // }

  // 平板 (768px - 991px) - 改为3列
  // @media (max-width: 991px) and (min-width: 768px) {
  //   .partners-box {
  //     gap: 16px;
  //     padding: 0 20px;
  //   }

  //   .item {
  //     flex: 0 0 calc((100% - 32px) / 3);
  //     max-width: calc((100% - 32px) / 3);
  //     min-height: 130px;
  //     padding: 16px 12px;

  //     .icon {
  //       width: 60px;
  //       height: 60px;
  //     }

  //     .company-name {
  //       font-size: 13px;
  //     }
  //   }
  // }

  // 手机横屏 (576px - 767px) - 改为2列
  // @media (max-width: 767px) {
  //   .partners-box {
  //     // gap: 14px;
  //     gap: 16px;
  //     padding: 0;
  //   }

  //   .item {
  //     // flex: 0 0 calc((100% - 14px) / 2);
  //     // max-width: calc((100% - 14px) / 2);
  //      flex: 0 0 calc((100% - 32px) / 3);
  //     max-width: calc((100% - 32px) / 3);
  //     min-height: 120px;
  //     padding: 14px 10px;

  //     .icon {
  //       width: 56px;
  //       height: 56px;
  //       margin-bottom: 8px;
  //     }

  //     .company-name {
  //       font-size: 12px;
  //     }
  //   }
  // }

}

.mod {
  padding: 0 20px;
}

/* ========== 响应式布局 ========== */

// ----- 超大屏桌面（1200px 以下） -----
@media (max-width: 1200px) {
  .banner-new {
    .swiper-title1 {
      font-size: 38px;
    }

    .swiper-title2 {
      font-size: 18px;
    }

    .contant-swiper2 {
      .left2 {
        left: 5%;
        padding-top: 40px;
        padding-bottom: 40px;
      }

      .right-box {
        width: 500px;
        padding-right: 80px;
        right: 0;
      }

      .right {
        width: 100%;
        height: auto;
        margin-left: 0;
        padding-right: 0;
        min-height: 400px;

        .swiper-card-item {
          width: 130px;
          min-height: 70px;
          padding: 8px;
        }

        .dw1 {
          bottom: 140px;
          left: 100px;
        }

        .dw2 {
          bottom: 280px;
          left: 160px;
        }

        .dw3 {
          top: 40px;
          left: 300px;
        }

        .dw4 {
          top: 60px;
          right: 200px;
        }

        .dw5 {
          top: 160px;
          right: 160px;
        }

        .dw6 {
          bottom: 120px;
          right: 80px;
          width: 160px;
        }

        .image {
          width: 280px;
        }
      }
    }

    .banner-bg {
      .banner-left {
        left: 5%;
        padding-top: 40px;
        padding-bottom: 40px;
      }
    }
  }

  .container {
    padding: 0;
  }

  .plant-wide {
    .step-box {
      width: 100%;
      padding: 0;

      .step-image {
        width: 100%;
        height: auto;
      }
    }
  }

  .back-advantage {
    .advantages-box {
      padding: 0;
      gap: 16px;
    }

    .item {
      flex: 0 0 calc((100% - 16px) / 2);
      max-width: calc((100% - 16px) / 2);
      min-height: 280px;
      padding: 20px;
    }
  }

  .cooperate-partenrs {

    .partners-box {
      gap: 16px;
      padding: 0;
    }

    .item {
      flex: 0 0 calc((100% - 48px) / 4);
      max-width: calc((100% - 48px) / 4);
      min-height: 140px;

      .icon {
        width: 64px;
        height: 64px;
      }
    }
  }
}

// ----- 笔记本/平板横屏（992px 以下） -----
@media (max-width: 992px) {
  .my-swiper {
    height: auto;
    min-height: 500px;
  }

  .banner-new {
    height: auto;
    min-height: 500px;

    .swiper-title1 {
      font-size: 32px;
    }

    .swiper-title2 {
      font-size: 16px;
    }

    .btn-zxzx {
      // margin: 30px auto 0;
    }

    .contant-swiper2 {
      height: auto;
      min-height: 500px;
      flex-direction: column;
      padding: 20px 16px;

      .left2 {
        position: relative;
        top: auto;
        left: auto;
        padding: 30px 0 20px;
        text-align: center;
        width: 100%;
      }

      .right-box {
        position: relative;
        width: 100%;
        height: auto;
        padding: 20px 0;
        top: auto;
        right: auto;
      }

      .right {
        min-height: 300px;

        .swiper-card-item {
          position: relative !important;
          width: 100%;
          min-height: auto;
          margin-bottom: 8px;
          top: auto !important;
          bottom: auto !important;
          left: auto !important;
          right: auto !important;
        }

        .image {
          display: none;
        }
      }
    }

    .banner-bg {
      height: auto;
      min-height: 500px;
      padding: 40px 20px;
      display: flex;
      align-items: center;

      img {
        max-height: 500px;
      }

      .banner-left {
        left: 5%;
        padding: 30px 0 20px;
        width: 100%;
      }
    }
  }

  .back-advantage {
    .advantages-box {
      gap: 16px;
    }

    .item {
      flex: 0 0 calc((100% - 16px) / 2);
      max-width: calc((100% - 16px) / 2);
      min-height: 280px;
      padding: 20px;
    }
  }

  .cooperate-partenrs {
    .partners-box {
      gap: 16px;
      padding: 0;
    }

    .item {
      flex: 0 0 calc((100% - 32px) / 3);
      max-width: calc((100% - 32px) / 3);
      min-height: 130px;
      padding: 16px 12px;

      .icon {
        width: 60px;
        height: 60px;
      }

      .company-name {
        font-size: 13px;
      }
    }
  }
}

// ----- 平板竖屏/手机横屏（767px 以下） -----
@media (max-width: 767px) {
  .home {
    padding-top: 60px;
  }

  .container {
    padding: 0;
  }

  .my-swiper {
    height: 200px;
    max-height: 200px;
    min-height: unset;
  }

  .banner-new {
    height: 200px;
    max-height: 200px;
    min-height: unset;

    .swiper-title1 {
      font-size: 24px;
    }

    .swiper-title2 {
      font-size: 14px;
    }

    .btn-zxzx {
      width: 140px;
      height: 44px;
      font-size: 16px;
      line-height: 44px;
      margin-top: 20px;
    }

    .contant-swiper2 {
      min-height: 400px;
      padding: 12px;

      .left2 {
        padding: 20px 0 10px;
      }

      .right {
        .swiper-card-item {
          p {
            font-size: 13px;
          }

          span {
            font-size: 11px;
          }
        }
      }
    }

    .banner-bg {
      height: 200px;
      max-height: 200px;
      min-height: unset;
      padding: 30px 16px;
      display: flex;
      align-items: center;

      img {
        height: 200px;
        max-height: 200px;
        min-height: unset;
      }

      .banner-left {
        left: 5%;
        padding: 0 0 10px 0;
      }
    }
  }

  .mod-title {
    padding: 30px 0 20px 0;

    .title {
      font-size: 24px;
    }

    .sed-title {
      font-size: 14px;
      padding-top: 10px;
    }
  }

  .back-tone {
    .mod-title {
      margin-bottom: 16px;
    }

    .cards-row {
      flex-direction: column;
      gap: 12px;
    }

    .card-col {
      flex: none;
      width: 100%;
    }

    .card-title {
      font-size: 16px;
      padding: 16px 0;
    }

    .card {
      height: auto;
      min-height: 200px;

      .up {
        .title {
          font-size: 16px;
        }

        .sub-title {
          font-size: 12px;
        }
      }

      .down {
        padding: 12px 16px;

        ul li {
          width: 100%;
          margin-bottom: 8px;
          font-size: 12px;

          &:nth-child(odd) {
            margin-right: 0;
          }
        }
      }

      &.custom {
        padding: 40px 16px 20px;
        height: auto;
        min-height: 200px;

        .title {
          font-size: 20px;
          margin: 0 0 8px;
        }

        .detail {
          margin: 0 0 16px;
          font-size: 14px;
        }

        img {
          display: none;
        }

        .btn {
          margin: 0 0 0;
          width: 120px;
          height: 40px;
          font-size: 14px;
          line-height: 40px;
        }
      }
    }
  }

  .plant-wide {
    .step-box {
      width: 100%;
      padding: 0;

      .step-image {
        width: 100%;
        height: auto;
      }
    }
  }

  .back-advantage {
    margin-bottom: 20px;
    padding: 0 12px;

    .advantages-box {
      gap: 16px;
      padding: 0;
    }

    .item {
      flex: 0 0 100%;
      max-width: 100%;
      min-height: auto;
      padding: 20px;

      .icon {
        width: 80px;
        height: 80px;
        margin: 0 auto 12px;
      }

      .title {
        font-size: 18px;
        margin-bottom: 12px;
        text-align: center;
      }

      .detail {
        font-size: 15px;
        line-height: 1.8;
      }
    }
  }

  .cooperate-partenrs {

    .partners-box {
      // gap: 14px;
      gap: 16px;
      padding: 0;
    }

    .item {
      // flex: 0 0 calc((100% - 14px) / 2);
      // max-width: calc((100% - 14px) / 2);
      flex: 0 0 calc((100% - 32px) / 3);
      max-width: calc((100% - 32px) / 3);
      min-height: 120px;
      padding: 14px 10px;

      .icon {
        width: 56px;
        height: 56px;
        margin-bottom: 8px;
      }

      .company-name {
        font-size: 12px;
      }
    }
  }
}
</style>